export default __webpack_public_path__ + "static/media/gijs02.5ded4ab4.png";